import { useDeviceType } from "@b2bportal/core-utilities";
import {
  DisruptionExerciseHeaderMobile,
  DisruptionExerciseHeaderDesktop,
  DisruptionExerciseHeaderDesktopWithLogo,
} from "@tenant/disruption";

export interface DisruptionExerciseHeaderProps {
  title: string;
  subtitle?: string;
  logo?: string;
  onBack: () => void;
  withLogo: boolean;
  rightNavElement?: JSX.Element;
}

export const DisruptionExerciseHeader = (
  props: DisruptionExerciseHeaderProps
) => {
  const { isDesktopAndUp } = useDeviceType();

  const desktopHeader = props.withLogo ? (
    <DisruptionExerciseHeaderDesktopWithLogo {...props} />
  ) : (
    <DisruptionExerciseHeaderDesktop {...props} />
  );

  return isDesktopAndUp ? (
    desktopHeader
  ) : (
    <DisruptionExerciseHeaderMobile {...props} />
  );
};

export default DisruptionExerciseHeader;
